import { render, staticRenderFns } from "./FarbkarteDetail.vue?vue&type=template&id=6f7c9072&scoped=true&"
import script from "./FarbkarteDetail.vue?vue&type=script&lang=js&"
export * from "./FarbkarteDetail.vue?vue&type=script&lang=js&"
import style0 from "./FarbkarteDetail.vue?vue&type=style&index=0&id=6f7c9072&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f7c9072",
  null
  
)

export default component.exports